/**
 *
 * FlashCardDetail
 *
 */

import { mapState } from 'vuex';

import FlashCardSide from '@/views/FlashCard/FlashCardDetail/components/FlashCard/FlashCardSide.vue';

export default {
  name: 'FlashCard',

  components: {
    FlashCardSide,
  },

  computed: {
    ...mapState('FlashCard/FlashCardDetail', {
      ms_flashCardDetail: 'flashCardDetail',
      ms_isShowAnswer: 'isShowAnswer',
    }),
  },
};
